<template>
  <div class="new_vip">
    <div class="content">
      <shop-order></shop-order>
    </div>
  </div>
</template>

<script>
import ShopOrder from "@/views/apply/comModule/mall/order/allOrder"
export default {
  data(){
    return{
    }
  },
  components: {
    ShopOrder
  }
}
</script>

<style lang="scss" scoped>
.new_vip{
  padding: 10px 15px;
  height: 100%;
  background: #f1f2f6;
  overflow: auto;
  .content{
    background: #fff;
    height: 100%;
  }
}
</style>